import { BuilderPreferences } from "../../src/entities/BuilderPreferences";
import { WebClient } from "./server/WebClient";

export const BuilderPreferenceService = {
	getPreferences: () => WebClient.Get<BuilderPreferences>(`api/BuilderPreferences/GetBuilderPreferences`),
	savePreferences: (preferences: BuilderPreferences) => WebClient.Post.Validated<undefined>(`api/BuilderPreferences/SaveBuilderPreferences`, preferences)
}
